import * as React from "react"
import {Box, Typography} from '@mui/material'
import {formatPrice} from "@ui-seeker/utils";

import {NotAllowedBlock} from "@components";
import {TABS_OFFERS} from "../../../@constants";

export default function priceCompetitorColumn(title) {
    return {
        name: 'PVR Competitor',
        label: title === TABS_OFFERS.DRUNI ? 'Precio Primor' : 'Precio Druni',
        options: {
            customBodyRowRenderLite: (value, row) => {
                return <Box sx={{ display: "flex", flexDirection: "column", alignItems: 'center', gap: 0.5 }}>

                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Typography component="span" fontWeight="bold">PVR:</Typography>
                        {typeof value === 'number' && <Typography variant="body2" sx={{ ml: 1 }}>{formatPrice(value, 'EUR')}</Typography>}
                        {typeof value !== 'number' && <NotAllowedBlock sx={{ ml: 1 }} />}
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Typography component="span" fontWeight="bold">PVP:</Typography>
                        {typeof row['PVP Competitor'] === 'number' && <Typography variant="body2" sx={{ ml: 1 }}>{formatPrice(row['PVP Competitor'], 'EUR')}</Typography>}
                        {typeof row['PVP Competitor'] !== 'number' && <NotAllowedBlock sx={{ ml: 1 }} />}
                    </Box>

                </Box>
            }
        }
    }
}